import { apiDelete, apiGet, apiPatch, apiPost } from './client.js';

export interface TicketPart {
  id: string;
  partName: string;
  partSku?: string | null;
  quantity: string;
  unitCost: string;
  totalCost: string;
  unitRetail: string;
  totalRetail: string;
  taxable: boolean;
  taxAmount: string;
  isOneTime: boolean;
  supplierName?: string | null;
  serialNumber?: string | null;
  imei?: string | null;
  inventoryItemId?: string | null;
  inventoryQtyOnHand?: number | null;
  isOutOfStock?: boolean;
  status: string;
  showOnReceipt: boolean;
}

export interface TicketPartsGroup {
  repairId: string;
  repairName: string;
  parts: TicketPart[];
}

export interface TicketPartsResponse {
  data: TicketPartsGroup[];
  totals: {
    partsCostTotal: string;
    partsRetailTotal: string;
    partsTaxTotal: string;
  };
}

export function getTicketParts(ticketId: string) {
  return apiGet<
    TicketPartsGroup[],
    { totals: TicketPartsResponse['totals'] }
  >(`/api/v1/tickets/${ticketId}/parts`).then((res) => ({
    data: res.data,
    totals: res.meta?.totals ?? {
      partsCostTotal: '0',
      partsRetailTotal: '0',
      partsTaxTotal: '0',
    },
  }));
}

export function addTicketPart(
  ticketId: string,
  body: {
    ticketRepairId: string;
    inventoryItemId?: string;
    serialId?: string;
    isOneTime?: boolean;
    partName?: string;
    supplierName?: string;
    quantity: number;
    unitCost?: number;
    unitRetail?: number;
    taxable?: boolean;
    showOnReceipt?: boolean;
    serialNumber?: string;
    imei?: string;
  },
) {
  return apiPost<
    TicketPart & { inventoryQtyOnHand?: number | null; isOutOfStock?: boolean },
    typeof body
  >(`/api/v1/tickets/${ticketId}/parts`, body).then((res) => ({
    data: res.data,
    warning: (res as { warning?: string }).warning,
    currentQty: (res as { currentQty?: number }).currentQty,
  }));
}

export function updateTicketPart(
  ticketId: string,
  partId: string,
  body: Record<string, unknown>,
) {
  return apiPatch<TicketPart, Record<string, unknown>>(
    `/api/v1/tickets/${ticketId}/parts/${partId}`,
    body,
  ).then((res) => res.data);
}

export function removeTicketPart(ticketId: string, partId: string) {
  return apiDelete<void>(`/api/v1/tickets/${ticketId}/parts/${partId}`);
}
